import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

type DrawerItem = {
  text: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  action: () => void;
  pathName: string;
};

export const getDrawerItemsByRole = () => {
  const drawerItems1: DrawerItem[] = [];
  const drawerItems2: DrawerItem[] = [];
  return { drawerItems1, drawerItems2 };
};
